import { render, staticRenderFns } from "./base-list.vue?vue&type=template&id=0153b3e9"
import script from "./base-list.vue?vue&type=script&lang=js"
export * from "./base-list.vue?vue&type=script&lang=js"
import style0 from "./base-list.vue?vue&type=style&index=0&id=0153b3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports